export const APP_PATHS = {
  home: '',
  userSettings: {
    root: 'user-settings',
    withPage: ':page',
    editUser: 'user/edit',
    editFamilyMember: 'familyMember/edit/:id',
    addFamilyMember: 'familyMember/add',
  },
  organization: {
    root: 'organization-settings',
    editFamilyMember: 'edit-family-member',
  },
  createOrganization: 'create-organization',
  termsAndConditions: 'terms-and-conditions',
  auth: {
    root: 'auth',
    loginMethod: 'login-method',
    applicationContext: 'application-context',
    authElectronicSignature: 'auth-electronic-signature',
    authDevelopers: 'auth-developers',
    firstLogin: 'first-login',
    verify: 'verify',
  },
  post: {
    root: 'post',
    inbox: 'inbox',
    sent: 'sent',
  },
  admin: {
    root: 'admin',
    users: 'users',
    userOrganizationDetailsPage: 'organizations/details',
    applications: 'applications',
    reports: 'reports',
    generate: 'generate',
    announcements: 'announcements',
    organizations: 'organizations',
    rules: 'rules',
    details: 'details',
    idDetails: ':id/details',
    edit: 'edit',
    idEdit: ':id/edit',
    add: 'add',
  },
};
